export class SearchMembershipPlanModel{
    public name :string ='';
    public pageSize: number = 10;
    public pageNumber: number = 1;
    public countryId :number = 0;
    public projectId: number;
}
